import script from "./OnboardFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardFrame.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardFrame.vue?vue&type=style&index=0&id=270a6314&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270a6314"]])

export default __exports__